// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__Y7tR0","title":"Info_title__a8EUC","selects":"Info_selects__2SYBq","requiredAsterisk":"Info_requiredAsterisk__Iw4_C"};